import React, { useState, useEffect } from "react";
import { withTheme } from "styled-components";
import {
  MarketoStyleWrapperBase,
  MarketoButtonStyle,
  MarketoEmailOptInStyle,
  MarketoFormElement
} from "storybook-components/MarketoForm";
import ScriptLoader from "../Helpers/ScriptLoader";

const MarketoForm = ({
  formId,
  onSuccessAnalyticsEvent,
  customOnSuccessEvent
}) => {
  const id = `mktoForm_${formId}`;
  const [isLoaded, setIsLoaded] = useState(false);
  const scriptSrc = "//info.mode.com/js/forms2/js/forms2.min.js";

  const isEmailOptForm = rowElement => {
    if (
      rowElement.querySelector("#optInGeneralCommunications") ||
      rowElement.querySelector("#LblEmail_Opt_In_GDRP__c_lead")
    ) {
      rowElement.classList.add("isEmailOptFormRow");
    }
  };

  const isRequiredForm = rowElement => {
    if (rowElement.querySelector(".mktoRequiredField")) {
      rowElement.classList.add("isRequiredFormRow");
    }
  };

  const hideUnwantedMarketoRows = () => {
    document.querySelectorAll(".mktoFormRow").forEach(rowElement => {
      isEmailOptForm(rowElement);
      isRequiredForm(rowElement);
    });
  };

  const formOnSuccessAnalytics = (successEventName, formValues) => {
    if (window && window.analytics) {
      window.analytics.track(
        successEventName, // event
        // properties
        {
          userEmail: formValues.Email || ""
        }
      );
    }
  };

  const formLoadCallback = form => {
    // In case of marketo issue, check for {form} so as not to explode the page
    if (form) {
      form.onSuccess(values => {
        if (onSuccessAnalyticsEvent) {
          formOnSuccessAnalytics(onSuccessAnalyticsEvent, values);
        }
        if (customOnSuccessEvent) {
          customOnSuccessEvent(values, form);
          // Return false to prevent the submission handler from continuing with default behavior
          return false;
        }
        form.getFormElem().hide();
        return true;
      });
      hideUnwantedMarketoRows();
    }
  };

  useEffect(() => {
    if (isLoaded) {
      window.MktoForms2.loadForm(
        "//info.mode.com",
        "538-HRN-944",
        formId,
        formLoadCallback
      );
    }
  }, [isLoaded, formId]);

  return (
    <MarketoStyleWrapperBase>
      <ScriptLoader
        scriptId={id}
        scriptSrc={scriptSrc}
        isLoadedCallback={() => setIsLoaded(true)}
      />
      <MarketoButtonStyle>
        <MarketoEmailOptInStyle>
          <MarketoFormElement id={id} />
        </MarketoEmailOptInStyle>
      </MarketoButtonStyle>
    </MarketoStyleWrapperBase>
  );
};

export default withTheme(MarketoForm);
